import {
	Length,
	IsPhoneNumber,
	IsEmail,
	IsNotEmpty,
	IsOptional,
	IsArray,
	ValidateNested,
	ArrayNotEmpty,
	ValidateIf,
} from 'class-validator';
import { Type } from 'class-transformer';
import { CreateChildFromFamilyDto } from './create-child.dto';
import { IsValidSendMethod } from '../../decorators/prefered-send-method.decorator';

export class CreateFamilyDto {
	@IsNotEmpty()
	districtId: string;

	@Length(1, 100)
	@IsNotEmpty({ message: 'Full Name is required' })
	fullName: string;

	@ValidateIf((obj) => !!obj.email)
	@IsEmail({}, { message: 'Incorrect Email' })
	email: string;

	@IsPhoneNumber(undefined, { message: 'Incorrect Phone Number' })
	phoneNumber: string;

	@Length(1)
	@IsNotEmpty({ message: 'Location is required' })
	location?: string;

	@ArrayNotEmpty({ message: 'Preferred language is required' })
	preferedLanguage: string[];

	@IsValidSendMethod()
	@IsNotEmpty({ message: 'Preferred Send Method is required' })
	preferedSendMethod: string;

	@IsOptional()
	imageUrl?: string;

	@IsArray()
	@ArrayNotEmpty()
	@ValidateNested({ each: true })
	@Type(() => CreateChildFromFamilyDto)
	children: Array<CreateChildFromFamilyDto>;
}
